import React, { useState, useEffect } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';

const AdminLayout = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const loggedIn = localStorage.getItem('adminLoggedIn') === 'true';
    setIsAuthenticated(loggedIn);
  }, []);

  if (isAuthenticated === null) {
    return <div>Verificando autenticação...</div>;
  }

  // Se não estiver autenticado E não estiver na página de login
  if (!isAuthenticated && !location.pathname.includes('/admin/login')) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="admin-layout">
      <Outlet />
    </div>
  );
};

export default AdminLayout;